
export default {//改变state里定义的变量的方法,调用方法是this.$store.commit('方法名','要改变的数据')
	setLoading(state, boolean) {
		state.isLoading = boolean;
	},
	setUser(state, user) {
		state.user = user;
	},
	clearUser(state) {
		state.user = null;
	},
}
